import { FC } from "react";
import { TestimonialSection } from "./component/TestimonialSection";
import { EnterpriseAuthContainer } from "./component/EnterpriseAuthContainer";
import { AuthHeader } from "./component/AuthHeader";
import { AuthAlternative } from "./component/AuthAlternative";
import { useFormik } from "formik";
import { emptySignupFormValue, signUpSchema } from "./validation";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/InputField";
import PasswordInput from "../../components/PasswordInput";
import Button from "../../components/Button";
import PasswordStrengthChecker from "./component/passwordChecker/PasswordStrengthChecker";

export const SignupPage: FC = () => {
  const navigate = useNavigate();

  const {
    errors,
    handleChange,
    values,
    touched,
    handleSubmit,
    isValid,
    dirty,
  } = useFormik({
    initialValues: emptySignupFormValue,
    validationSchema: signUpSchema,
    onSubmit: (values) => {
      navigate("/enterprise/work-name", { state: values });
    },
  });

  const isButtonDisabled = !isValid || !dirty;

  return (
    <div className="flex h-screen flex-col md:flex-row">
      <EnterpriseAuthContainer>
        <>
          <AuthHeader
            title="Sign Up"
            subtitle="Create an account to get started"
          />
          <form className="" onSubmit={handleSubmit}>
            <div className="flex flex-col lg:flex-row lg:gap-4">
              <InputField
                name="firstName"
                placeholder="First Name"
                label="First Name"
                error={(touched?.firstName && errors?.firstName) || ""}
                value={values.firstName}
                onChange={handleChange}
              />
              <InputField
                name="lastName"
                placeholder="Last Name"
                label="Last Name"
                error={(touched?.lastName && errors?.lastName) || ""}
                value={values.lastName}
                onChange={handleChange}
              />
            </div>
            <InputField
              name="email"
              placeholder="Enter Email"
              label="Email"
              error={(touched?.email && errors?.email) || ""}
              value={values.email}
              onChange={handleChange}
            />
            <PasswordInput
              name="password"
              label="Password"
              placeholder="••••••••••••"
              error={(touched?.password && errors?.password) || ""}
              value={values.password}
              onChange={handleChange}
            />
            {values.password.length > 0 && (
              <PasswordStrengthChecker password={values.password} />
            )}
            <Button
              text="Sign Up"
              className="w-full mt-6"
              type={isButtonDisabled ? "muted" : "primary"}
              disabled={isButtonDisabled}
            />
          </form>
          <AuthAlternative
            description="Already have an account?"
            buttonText=" Sign In"
            buttonLink="/enterprise/signin"
          />
        </>
      </EnterpriseAuthContainer>

      <TestimonialSection />
    </div>
  );
};
